import React from 'react';
import PropTypes from 'prop-types';

const ClientRelationship = ({ clientRelationship }) => {
  const careCoordinatorName = clientRelationship[0]?.attributes?.care_coordinator_name;

  return (
    <div className="flex items-center">
      <div className="flex flex-col space-y-1 max-w-xs break-words">
        <div className="block">
          {careCoordinatorName || '--'}
        </div>
      </div>
    </div>
  );
};

ClientRelationship.propTypes = {
  clientRelationship: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ClientRelationship;
